import { JS_PROFILING_COOKIE_NAME, createCookie, eraseCookie } from '@talos/kyoko';
import { useEffect } from 'react';
import { OrgConfigurationKeys } from './OrgConfigurationKeys';
import type { OrgConfigurationContextProps } from './OrgConfigurationProvider';

const JS_PROFILING_COOKIE_TTL_1Y_MS = 365 * 24 * 60 * 60 * 1000;

export function useSyncJSProfilingCookie(isLoaded: boolean, getConfig: OrgConfigurationContextProps['getConfig']) {
  useEffect(() => {
    if (!isLoaded) {
      return;
    }
    if (getConfig(OrgConfigurationKeys.EnableJSProfiling.key, false)) {
      createCookie(JS_PROFILING_COOKIE_NAME, 'true', {
        expires: new Date(Date.now() + JS_PROFILING_COOKIE_TTL_1Y_MS),
      });
    } else {
      eraseCookie(JS_PROFILING_COOKIE_NAME);
    }
  }, [getConfig, isLoaded]);
}
